<script lang="ts">
    import Exam from "./ExamTypeDisplayer.svelte";
    import cssVars from 'svelte-css-vars';
    import Manager from "../../application/SyllabusManager/models/Manager.ts";
    import {createEventDispatcher} from "svelte";

    export let id;
    export let manager: Manager;
    export let targetId;
    export let languages;

    const dispatch = createEventDispatcher();

    let subjectData;
    let highlightLevel;
    let styleVars;

    $: subjectData = manager.subjectManager.getSubject(parseInt(id));
    $: highlightLevel = manager.subjectManager.getHighlightLevel(subjectData, $targetId);
    $: styleVars = {highlightColor: getColor(highlightLevel)};

    function getColor(intensity) {
        let red = 9;
        let green = 68
        let blue = 104;
        if (intensity > 0) {
            blue = 104 - (15 * intensity);
        } else {
            red = 9 + (10 * intensity * (-1));
        }

        return 'rgb(' + red + ',' + green + ',' + blue + ')';
    }

    function toggleModal() {
        dispatch('cardClick', {
            data: subjectData,
            type: "card"
        });
    }
</script>


<div class="card"
     use:cssVars={styleVars}
     class:highlighted={highlightLevel!==0 && !isNaN(highlightLevel)}
     on:mouseover={()=>$targetId = subjectData.id}
     on:mouseleave={()=>$targetId = null}
     on:click={()=>toggleModal()}
>
    {#if subjectData !== null}
        <div class="subjectDetails">
            <div class="subjectCode is-size-7 has-text-centered is-bold">{subjectData.code}</div>
            {#if $languages === 'hu'}
                <div class="subjectName is-size-7 has-text-centered">{subjectData.nameHu}</div>
            {/if}
            {#if $languages === 'en'}
                <div class="subjectName is-size-7 has-text-centered">{subjectData.nameEn}</div>
            {/if}
            <div class="subjectData">
                <div class="creditCount has-text-centered">
                    Kredit: {subjectData.credits}
                </div>
                <div class="examType">
                    <Exam text={subjectData.examType} languages={languages}/>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>

    .highlighted {
        background-color: var(--highlightColor);
        cursor: pointer;
    }

    .highlighted > .subjectDetails > .subjectCode {
        color: white;
    }

    .highlighted > .subjectDetails > .subjectName {
        color: white;
    }

    .highlighted > .subjectDetails > .subjectData {
        color: #dcdcdc;
    }

    .card {
        display: flex;
        min-height: 100px;
        max-height: 100px;
        min-width: 140px;
        max-width: 140px;
    }

    .subjectCode {
        font-weight: bold
    }

    .subjectDetails {
        height: 100px;
        width: 150px;
        display: grid;
        grid-template-rows: auto auto auto;
    }

    .subjectName {
        text-align: center !important;
        font-size: 14px;
        overflow: hidden;
    }

    .subjectData {
        text-align: center;
        font-size: 12px;
        color: #818181;
        display: grid;
        grid-template-columns: 50% 50%;
    }
</style>
